const russia = {
  id: 1,
  code: "7",
  country: "Россия",
};

const ukraine = {
  id: 2,
  code: "380",
  country: "Украина",
};

const kazakhstan = {
  id: 3,
  code: "7",
  country: "Казахстан",
};

const belarus = {
  id: 4,
  code: "375",
  country: "Беларусь",
};

export const countries = [russia, ukraine, kazakhstan, belarus];

export const phoneCountryCodes = ["Россия", "Украина", "Казахстан", "Беларусь"];
